import '@fontsource-variable/readex-pro';
import '../css/app.css';

import InlineSvg from '@/components/shared/InlineSvg.vue';
import { createInertiaApp, Link } from '@inertiajs/vue3';
import * as Sentry from '@sentry/vue';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createPinia } from 'pinia';
import type { DefineComponent } from 'vue';
import { createApp, h } from 'vue';
import { ZiggyVue } from 'ziggy-js';
import { initializeTheme } from './composables/admin/useAppearance';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./pages/${name}.vue`, import.meta.glob<DefineComponent>('./pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const pinia = createPinia();
        const app = createApp({ render: () => h(App, props) });

        if (String(import.meta.env.VITE_DISABLE_SENTRY).toLowerCase() !== 'true') {
            Sentry.init({
                app,
                dsn: import.meta.env.VITE_SENTRY_DSN || '',
                sendDefaultPii: true,
                integrations: [
                    Sentry.browserTracingIntegration(),
                    Sentry.replayIntegration(),
                    Sentry.captureConsoleIntegration({
                        levels: ['error', 'warn'],
                    }),
                    Sentry.httpClientIntegration(),
                ],
                environment: import.meta.env.VITE_APP_ENV || 'production',
                tracesSampleRate: 0.1,
                // Session Replay
                replaysSessionSampleRate: 0.1,
                replaysOnErrorSampleRate: 1.0, // 100% of errors are recorded
            });
        }

        app.use(plugin).use(ZiggyVue).use(pinia).component('Link', Link).component('InlineSvg', InlineSvg).mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

// This will set light / dark mode on page load...
initializeTheme();
